<template>
  <div class="p-terms">
    <Container class="p-terms_container">
      <div class="success__registration">
        <div class="success__registration-body registration-body">
          <h1 class="registration-body-item bold-attention-text-item mb-20 ft-size-24">
            Congratulations on registering — you’ve unlocked another <span class="green-text">free</span>  generation.
          </h1>
          <p class="registration-body-item bold-attention-text-item">
            Choose your fantasy: bikini, latex, or lingerie — and keep exploring your desires.
          </p>
          <p class="registration-body-item bold-attention-text-item mt-20">
            Want to see ALL?
          </p>
          <p class="registration-body-item bold-attention-text-item mt-20">
            Full nudity and access to <span class="green-text">15 sexy poses and roles</span>  become available after topping up your account.
          </p>
          <p class="registration-body-item bold-attention-text-item mt-20">
            <span class="green-text">🎁 USE PROMO CODE <span class=" underline-promo" @click="copyPromoCode">{{ promoCode }}</span> WITHIN 10 MINUTES AND GET 80% OFF YOUR FIRST CREDIT PACK.</span>
          </p>

          <p class="registration__example mt-20 mb-20">
          <span class="registration__example-item">
            <img src="@/assets/cumshot/teacher.webp" alt="teacher" />
          </span>

            <span class="registration__example-item">
            <img src="@/assets/breast/nun.webp" alt="nun" />
           </span>

            <span class="registration__example-item">
            <img src="@/assets/bbc/student.webp" alt="student" />
            </span>

            <span class="registration__example-item">
            <img src="@/assets/mission/teacher.webp" alt="teacher" />
            </span>

            <span class="registration__example-item">
            <img src="@/assets/mission/nun.webp" alt="teacher" />
            </span>

            <span class="registration__example-item">
            <img src="@/assets/filters-bikini/black.webp" alt="teacher" />
            </span>
          </p>
          <p class="registration__example-text">
            <span class="generations-over_example-text-plus">+</span> 15more
          </p>


        </div>
        <p class="capitalize bold-attention-text-item mt-10 mb-10">🔓 What you unlock after activation:</p>
        <ul class="success__registration-list registration__list mb-20">
          <li class="registration__list-item">
            <p class="registration__list-item-text">
              ✅ Full nudity
            </p>
          </li>
          <li class="registration__list-item">
            <p class="registration__list-item-text">
              ✅ 15 seductive poses
            </p>
          </li>
          <li class="registration__list-item">
            <p class="registration__list-text">
              ✅ Characters and roles that ignite your fantasies
            </p>
          </li>
          <li class="registration__list-item">
            <p class="registration__list-item-text">
              ✅ Instant, unlimited access
            </p>
          </li>
        </ul>

        <div class="success__registration-footer registration__footer">
          <button
              @click="redirectToOrder"
              class="registration__footer-btn green-btn green-btn-with-pulse"
          >
            Top Up with Discount
          </button>

          <p class="registration__footer-promo">Promo Code: <span class="green-text underline-promo " @click="copyPromoCode">{{ promoCode }}</span> – copy and use at checkout.</p>
        </div>
      </div>
    </Container>
  </div>
</template>

<script>
import Container from "../components/layout-positions/Container";
import { useRouter } from 'vue-router'
import { ref  } from "vue";
import { useStore } from "vuex";

export default {
  name: "SuccessRegistration",
  components: {
    Container
  },
  setup () {
    const router = useRouter();
    const store = useStore();
    const promoCode = ref('SMNKD80');

    const redirectToOrder = () => {
      router.push({
        name: "BuyCredits",
        query: { promo: promoCode.value }
      });
    };

    const copyPromoCode = async () => {
      try {
        await navigator.clipboard.writeText(promoCode.value);
        store.dispatch("handleToast", {
          text: "Promo code copied!",
          type: "SUCCESS",
        });
      } catch (err) {
        console.error('Copy failed:', err);
      }
    };

    return {
      copyPromoCode,
      redirectToOrder,
      promoCode
    }
  }
}
</script>
<style lang="scss" scoped>
.registration__example {
  display: flex;
  justify-content: center;
  place-items: center;
  gap: 25px;
  position: relative;

  @media screen and (max-width: 1024px) {
    gap: 15px;
  }

  &-arrow {
    width: 75px;
    height: 200px;
    position: absolute;
    top: 50%;
    left: 97%;

    @media screen and (max-width: 1024px) {
      top: 104%;
      left: 80%;
      width: 34px;
      height: 90px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &-item {
    max-width: 130px;
    height: 200px;
    min-height: 70px;
    flex-shrink: 0;
    border-radius: 2vw;
    border: 2px solid #ACF601;
    overflow: hidden;



    @media screen and (max-width: 990px) {
      &:nth-last-child(1) {
        display: none;
      }
    }

    @media screen and (max-width: 780px) {
      &:nth-last-child(2) {
        display: none;
      }
    }

    @media screen and (max-width: 610px) {
      &:nth-last-child(3) {
        display: none;
      }
    }

    @media screen and (max-width: 500px) {
      &:nth-last-child(4) {
        display: none;
      }
    }


    @media screen and (min-width: 1440px) {
      border-radius: 30px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &-text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    span {
      color: #ACF601;
      text-align: center;
      font-size: 44px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
}

.registration__list {
  display: grid;
  grid-template-columns: 2fr 1fr;
  margin: 20px auto;
  max-width: 900px;

  @media screen and (max-width: 680px) {
    grid-template-columns: 1fr 1fr;
    gap: 5px !important;
  }

  &-item {
    p {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
      text-transform: capitalize;

      @media screen and (max-width: 680px) {
        font-size: 16px;
      }
    }
  }
}

.registration__footer {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  &-btn {
    padding: 20px;
    font-weight: bold;
    max-width: 300px;
    font-size: 20px;
    margin-bottom: 20px;
  }

  &-promo {
    margin-bottom: 40px;
    span {
      cursor: pointer;
      text-decoration: underline;
      font-weight: bold;
    }
  }
}

.success__registration {
  margin: 0 20px;
  &-list {
    gap: 25px;
    list-style: none;

    &-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 25px;

      &-icon {
        img {
          width: 30px;
          height: 30px;
        }
      }

      &-text {
        font-size: 20px;
        line-height: 100%;
        color: #FFF;
        font-style: normal;
        font-weight: bold;

        span {
          color: #ACF601;
        }
      }
    }
  }

}
</style>
